import { render, staticRenderFns } from "./formWizard.vue?vue&type=template&id=fc672ab2&"
import script from "./formWizard.vue?vue&type=script&lang=js&"
export * from "./formWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports